import { APP_STATUS } from "../types";
const initialState = {
  initialized: false,
  fullResponse: null,
  metadata: null,
  sesion: null,
};

export default function appStatus(state = initialState, action) {
  switch (action.type) {
    case APP_STATUS:
      return {
        ...state,
        initialized: true,
        fullResponse: action.payload.allData.fullResponse,
        metadata: action.payload.allData.metadata,
        sesion: action.payload.allData.sesion,
      };

    default:
      return state;
  }
}
